import { http } from '@/utils/http';
import { IExhibitionBadgeList } from '@/views/exhibitor-badge/_cmn/form';

/** 展商胸卡list接口 */
export const badgeList = () => {
  return http.post<any, IExhibitionBadgeList>('/pcb/api/exhibit/badge/list');
};

/** 展商胸卡add接口 */
export const addBadge = data => {
  return http.post<any, string>('/pcb/api/exhibit/badge/add', data);
};

/** 展商胸卡update接口 */
export const updateBadge = data => {
  return http.post<any, string>('/pcb/api/exhibit/badge/update', data);
};

/** 展商胸卡update接口 */
export const deleteBadge = id => {
  return http.get<any, string>(`/pcb/api/exhibit/badge/delete/${id}`);
};

/** 展商胸卡上传附件*/
export const importBadge = data => {
  return http.post<any, Blob>('/pcb/api/exhibit/badge/import', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    silent: true,
    responseType: 'blob',
    timeout: 5 * 60 * 1000,
  });
};

/** 展商胸卡上传附件*/
export const updateBadgeContact = data => {
  return http.post<any, string>('/pcb/api/exhibit/badge/contacts', data);
};
